<template>
  <aside class="company-summary-rail">
    <div class="company-summary-rail__surface">
      <section class="company-summary-rail__section company-summary-rail__section--completion">
        <p class="company-summary-rail__eyebrow">Completitud</p>

        <div class="company-summary-rail__completion-head">
          <strong class="company-summary-rail__completion-value">
            {{ completion.percentage }}%
          </strong>
          <span class="company-summary-rail__completion-copy">Ficha completa</span>
        </div>

        <div class="company-summary-rail__progress">
          <span
            class="company-summary-rail__progress-fill"
            :style="{ width: `${completion.percentage}%` }"
          ></span>
        </div>

        <ul v-if="completion.missing && completion.missing.length" class="company-summary-rail__list">
          <li v-for="item in completion.missing" :key="item">
            {{ item }}
          </li>
        </ul>
      </section>

      <section class="company-summary-rail__section">
        <p class="company-summary-rail__eyebrow">Resumen</p>

        <div class="company-summary-rail__stats">
          <div class="company-summary-rail__stat">
            <span class="company-summary-rail__stat-label">Contactos</span>
            <strong class="company-summary-rail__stat-value">{{ stats.contacts }}</strong>
          </div>
          <div class="company-summary-rail__stat">
            <span class="company-summary-rail__stat-label">Direcciones</span>
            <strong class="company-summary-rail__stat-value">{{ stats.addresses }}</strong>
          </div>
          <div class="company-summary-rail__stat">
            <span class="company-summary-rail__stat-label">Socios</span>
            <strong class="company-summary-rail__stat-value">{{ stats.partners }}</strong>
          </div>
          <div class="company-summary-rail__stat">
            <span class="company-summary-rail__stat-label">Rep. legales</span>
            <strong class="company-summary-rail__stat-value">{{ stats.legalRepresentatives }}</strong>
          </div>
          <div class="company-summary-rail__stat">
            <span class="company-summary-rail__stat-label">Otras rel.</span>
            <strong class="company-summary-rail__stat-value">{{ stats.otherRelationships }}</strong>
          </div>
          <div class="company-summary-rail__stat">
            <span class="company-summary-rail__stat-label">Secretos</span>
            <strong class="company-summary-rail__stat-value">{{ stats.secrets }}</strong>
          </div>
          <div class="company-summary-rail__stat">
            <span class="company-summary-rail__stat-label">Contratos</span>
            <strong class="company-summary-rail__stat-value">{{ stats.contracts }}</strong>
          </div>
          <div class="company-summary-rail__stat">
            <span class="company-summary-rail__stat-label">Ctas. bancarias</span>
            <strong class="company-summary-rail__stat-value">{{ stats.bankAccounts }}</strong>
          </div>
        </div>
      </section>

      <section class="company-summary-rail__section company-summary-rail__section--health">
        <p class="company-summary-rail__eyebrow">Salud operativa</p>

        <div class="company-summary-rail__health" :class="healthClass">
          {{ health.label }}
        </div>

        <div v-if="lastActivity" class="company-summary-rail__activity">
          <p class="company-summary-rail__activity-label">Ultima actividad</p>
          <p class="company-summary-rail__activity-value">
            {{ lastActivity.title || lastActivity.label }}
          </p>
          <p v-if="lastActivity.created_at" class="company-summary-rail__activity-date">
            {{ formatDate(lastActivity.created_at) }}
          </p>
        </div>
      </section>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'CompanySummaryRail',
  props: {
    completion: {
      type: Object,
      required: true
    },
    stats: {
      type: Object,
      required: true
    },
    health: {
      type: Object,
      required: true
    },
    lastActivity: {
      type: Object,
      default: null
    }
  },
  computed: {
    healthClass () {
      const tone = this.health && this.health.tone ? this.health.tone : 'neutral'
      return `company-summary-rail__health--${tone}`
    }
  },
  methods: {
    formatDate (value) {
      return value ? new Date(value).toLocaleString() : ''
    }
  }
}
</script>

<style scoped>
.company-summary-rail {
  min-width: 0;
}

.company-summary-rail__surface {
  display: grid;
  gap: 1rem;
  padding: 0.95rem;
  border: 1px solid rgba(110, 91, 66, 0.08);
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 252, 247, 0.9), rgba(246, 239, 231, 0.82));
}

.company-summary-rail__section + .company-summary-rail__section {
  padding-top: 0.95rem;
  border-top: 1px solid rgba(95, 76, 52, 0.08);
}

.company-summary-rail__eyebrow {
  margin: 0 0 0.68rem;
  font-size: 0.68rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(58, 46, 33, 0.48);
}

.company-summary-rail__completion-head {
  display: flex;
  align-items: baseline;
  gap: 0.42rem;
}

.company-summary-rail__completion-value {
  font-size: 1.85rem;
  line-height: 1;
  color: #211913;
}

.company-summary-rail__completion-copy {
  color: rgba(45, 35, 26, 0.58);
  font-size: 0.86rem;
}

.company-summary-rail__progress {
  height: 10px;
  margin-top: 0.7rem;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(92, 72, 48, 0.08);
}

.company-summary-rail__progress-fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2b231c 0%, #8a6842 100%);
}

.company-summary-rail__list {
  margin: 0.75rem 0 0;
  padding-left: 1rem;
  color: #59483a;
  font-size: 0.84rem;
  line-height: 1.35;
}

.company-summary-rail__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.company-summary-rail__stat {
  padding: 0.68rem 0.65rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.34);
}

.company-summary-rail__stat-label {
  display: block;
  margin-bottom: 0.14rem;
  color: rgba(58, 46, 33, 0.5);
  font-size: 0.66rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.company-summary-rail__stat-value {
  color: #241c16;
  font-size: 0.98rem;
}

.company-summary-rail__health {
  display: inline-flex;
  align-items: center;
  min-height: 2rem;
  width: fit-content;
  padding: 0.36rem 0.74rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
}

.company-summary-rail__health--good {
  background: rgba(77, 140, 97, 0.12);
  color: #2f6a43;
}

.company-summary-rail__health--warning {
  background: rgba(184, 139, 59, 0.12);
  color: #8a6520;
}

.company-summary-rail__health--critical {
  background: rgba(168, 78, 78, 0.1);
  color: #8a3f3f;
}

.company-summary-rail__health--neutral {
  background: rgba(95, 107, 122, 0.12);
  color: #5a6574;
}

.company-summary-rail__activity {
  margin-top: 0.9rem;
}

.company-summary-rail__activity-label {
  margin: 0 0 0.2rem;
  color: rgba(58, 46, 33, 0.48);
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.company-summary-rail__activity-value {
  margin: 0;
  color: #241c16;
  font-weight: 600;
  line-height: 1.32;
}

.company-summary-rail__activity-date {
  margin: 0.14rem 0 0;
  color: rgba(45, 35, 26, 0.56);
  font-size: 0.8rem;
}

@media (min-width: 1600px) and (max-width: 1799px) {
  .company-summary-rail__surface {
    gap: 0.92rem;
    padding: 0.9rem;
  }

  .company-summary-rail__section + .company-summary-rail__section {
    padding-top: 0.9rem;
  }

  .company-summary-rail__completion-value {
    font-size: 1.72rem;
  }

  .company-summary-rail__stat {
    padding: 0.64rem 0.62rem;
  }

  .company-summary-rail__list {
    margin-top: 0.7rem;
    font-size: 0.82rem;
  }
}

@media (min-width: 1800px) {
  .company-summary-rail__surface {
    gap: 0.85rem;
    padding: 0.85rem;
  }

  .company-summary-rail__section + .company-summary-rail__section {
    padding-top: 0.85rem;
  }

  .company-summary-rail__completion-value {
    font-size: 1.65rem;
  }

  .company-summary-rail__stats {
    gap: 0.42rem;
  }

  .company-summary-rail__stat {
    padding: 0.6rem 0.58rem;
  }

  .company-summary-rail__list {
    margin-top: 0.65rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 980px) {
  .company-summary-rail__surface {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }

  .company-summary-rail__section + .company-summary-rail__section {
    padding-top: 0;
    border-top: 0;
  }
}

@media (max-width: 640px) {
  .company-summary-rail__surface {
    grid-template-columns: 1fr;
  }

  .company-summary-rail__stats {
    grid-template-columns: 1fr;
  }
}
</style>

